import React, { FC, PropsWithChildren } from 'react';
import TimeField, { TimeFieldProps } from './TimeField';

const UtcTimeField: FC<
PropsWithChildren<Omit<TimeFieldProps, 'format' | 'utc'>>
> = props => <TimeField {...props} utc format="HH:mm" />;

export default UtcTimeField;
